import React, { useRef } from "react";
import { FiPlus } from "react-icons/fi";
import Label from "../../../components/BaseUI/Label";
import {
  EVENT_VARIABLES,
  insertVariableToken,
  previewTemplateText,
} from "../Notifications/constants";
import styles from "./VariableInsertField.module.scss";

export default function VariableInsertField({
  label,
  required,
  value,
  onChange,
  eventType,
  multiline = false,
  placeholder,
  rows = 4,
}) {
  const fieldRef = useRef(null);
  const vars = EVENT_VARIABLES[eventType] || [];
  const preview = previewTemplateText(value, eventType);

  const insertVar = (variable) => {
    const el = fieldRef.current;
    const start = el?.selectionStart ?? (value || "").length;
    const end = el?.selectionEnd ?? start;
    const { text, cursor } = insertVariableToken(value, variable.label, start, end);
    onChange(text);
    requestAnimationFrame(() => {
      if (el) {
        el.focus();
        el.setSelectionRange(cursor, cursor);
      }
    });
  };

  return (
    <div className={styles.field}>
      <Label required={required}>{label}</Label>
      {multiline ? (
        <textarea
          ref={fieldRef}
          className={styles.textarea}
          rows={rows}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
        />
      ) : (
        <input
          ref={fieldRef}
          type="text"
          className={styles.input}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
        />
      )}

      {vars.length > 0 && (
        <div className={styles.chipsSection}>
          <p className={styles.chipsLabel}>Mesaja bilgi eklemek için tıklayın</p>
          <div className={styles.chipsScroller}>
            <div className={styles.chipsTrack}>
              {vars.map((v) => (
                <button
                  key={v.key}
                  type="button"
                  className={styles.chip}
                  onClick={() => insertVar(v)}
                >
                  <FiPlus className={styles.chipIcon} aria-hidden />
                  {v.label}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}

      {preview && (
        <div className={styles.preview}>
          <span className={styles.previewLabel}>Önizleme</span>
          <span className={styles.previewText}>{preview}</span>
        </div>
      )}
    </div>
  );
}
